import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight, MdSkipNext, MdSkipPrevious } from 'react-icons/md';



function MyPagination({ paginationData,PAGE_SIZE, currentPage, setCurrentPage }) {
  const count = paginationData?.count
  const next = paginationData?.next
  const previous = paginationData?.previous
  const results = paginationData?.results

  
  const pageCount = Math.ceil(count / PAGE_SIZE);
  const [widthPage, setWitdhPage] = useState(window.innerWidth);

  const MAX_VISIBLE_PAGES = widthPage>=500 ? 5 : 3; 

  const { t } = useTranslation();
  const handlePageClick = (newPage) => {
    setCurrentPage(newPage);
    // onPageChange(newPage);
  };
  useEffect(() => {
    function handleResize() {
      setWitdhPage(window.innerWidth)
    }

    window.addEventListener("resize", handleResize);
  },[])

  const renderPageButtons = () => {
    const pageButtons = [];
    
    // Calculate the range of visible page buttons.
    let startPage = Math.max(0, currentPage - Math.floor(MAX_VISIBLE_PAGES / 2));
    let endPage = Math.min(pageCount - 1, startPage + MAX_VISIBLE_PAGES - 1);
    
    // Adjust the startPage if the endPage is at the end.
    if (endPage === pageCount - 1) {
      startPage = Math.max(0, endPage - MAX_VISIBLE_PAGES + 1);
    }

    if (startPage > 0 && widthPage < 500) {
      pageButtons.push(
        <IconButton
          key="skip-prev"
          size="sm"
          rounded="lg"
          variant="ghost"
          colorScheme="gray"
          onClick={() => handlePageClick(0)}
          className="pagination-button"
          isDisabled={currentPage === 0}
          icon={<MdSkipPrevious size={18} />}
        />
      );
    }
    // Add "Précédent" button and disable it if there is only one page.  
    pageButtons.push(
      <IconButton
        key="prev"
        size="sm"
        rounded="lg"
        variant="ghost"
        colorScheme="gray"
        onClick={() => handlePageClick(currentPage - 1)}
        className="pagination-button"
        isDisabled={currentPage === 0}
        icon={<MdKeyboardDoubleArrowLeft size={18} />}
      />
    );

    if (startPage > 0 && widthPage >= 500) {
      pageButtons.push(
        <React.Fragment key="start-dots">
          <Button
            size="sm"
            rounded="lg"
            variant={0 === currentPage ? "solid" : "ghost"}
            colorScheme={0 === currentPage ? "purple" : "gray"}
            boxShadow={0 === currentPage ? "0 2px 8px rgba(128, 90, 213, 0.35)" : "none"}
            fontWeight="600"
            className="pagination-button"
            onClick={() => handlePageClick(0)}
          >
            1
          </Button>
          <Text fontSize="md" fontWeight="600" color="gray.400" px={1}>...</Text>
        </React.Fragment>
      );
    }
    // Add page buttons with dots
    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <Button
          key={i}
          size="sm"
          rounded="lg"
          variant={i === currentPage ? "solid" : "ghost"}
          colorScheme={i === currentPage ? "purple" : "gray"}
          boxShadow={i === currentPage ? "0 2px 8px rgba(128, 90, 213, 0.35)" : "none"}
          fontWeight="600"
          onClick={() => handlePageClick(i)}
          className="pagination-button"
        >
          {i + 1}
        </Button>
      );
    }
    if (endPage < pageCount - 1 && widthPage >= 500) {
      pageButtons.push(
        <React.Fragment key="end-dots">
          <Text fontSize="md" fontWeight="600" color="gray.400" px={1}>...</Text>
          <Button
            size="sm"
            rounded="lg"
            variant={pageCount - 1 === currentPage ? "solid" : "ghost"}
            colorScheme={pageCount - 1 === currentPage ? "purple" : "gray"}
            boxShadow={pageCount - 1 === currentPage ? "0 2px 8px rgba(128, 90, 213, 0.35)" : "none"}
            fontWeight="600"
            className="pagination-button"
            onClick={() => handlePageClick(pageCount - 1)}
          >
            {pageCount}
          </Button>
        </React.Fragment>
      );
    }
    // Add "Suivant" button and disable it if there is only one page.
    pageButtons.push(
      <IconButton
        key="next"
        size="sm"
        rounded="lg"
        variant="ghost"
        colorScheme="gray"
        onClick={() => handlePageClick(currentPage + 1)}
        className="pagination-button"
        isDisabled={currentPage === pageCount - 1}
        icon={<MdKeyboardDoubleArrowRight size={18} />}
      />
    );
    if (endPage < pageCount - 1 && widthPage < 500) {
      pageButtons.push(
        <IconButton
          key="skip-next"
          size="sm"
          rounded="lg"
          variant="ghost"
          colorScheme="gray"
          className="pagination-button"
          onClick={() => handlePageClick(pageCount - 1)}
          icon={<MdSkipNext size={18} />}
        />
      );
    }

    return pageButtons;
  };

  return (
    <Box my="4">
      <HStack justify="center" align="center">
        {renderPageButtons()}
      </HStack>
    </Box>
  );
}

export default MyPagination;
